/**
 * WormSprite — Individual worm hidden beneath the dirt layer.
 *
 * Starts invisible, plays a pop animation when revealed.
 * Positioned absolutely within the overlay container.
 */

interface WormSpriteProps {
  x: number;
  y: number;
  rotation: number;
  revealed: boolean;
  baitPerWorm: number;
}

export function WormSprite({ x, y, rotation, revealed, baitPerWorm }: WormSpriteProps) {
  return (
    <div
      className="absolute pointer-events-none"
      style={{
        left: x,
        top: y,
        transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
      }}
    >
      {/* Worm emoji */}
      <div
        className={`text-4xl transition-all duration-300 ${
          revealed
            ? 'scale-100 opacity-100'
            : 'scale-0 opacity-0'
        }`}
        style={{ filter: revealed ? 'drop-shadow(0 0 8px rgba(200, 150, 50, 0.8))' : undefined }}
      >
        🪱
      </div>

      {/* "+2 worms!" float text */}
      {revealed && (
        <div
          className="absolute left-1/2 -translate-x-1/2 text-sm font-bold text-amber-300 whitespace-nowrap pointer-events-none"
          style={{
            top: -24,
            animation: 'wormFoundFloat 1.2s ease-out forwards',
          }}
        >
          +{baitPerWorm} worms!
        </div>
      )}
    </div>
  );
}
